export default __webpack_public_path__ + "static/media/success.fd05fd96.png";